import { createAction, props } from '@ngrx/store';
import { PostChangePasswordRequest } from '@models/usuarios.model';
import { OraculoAPIUser, PostLoginRequest, AuthMethods, TotpRegisterAuth } from '@models/auth.model';

export enum Types {
  // Token
  UPDATE_TOKENS = '[Session State] Update Token',
  // Refresh Token
  REFRESH_TOKEN_SUCCESS = '[Session State] Refresh Token Success',
  REFRESH_TOKEN_ERROR = '[Session State] Refresh Token Error',
  // Login
  LOGIN = '[Session State] Login',
  LOGIN_SUCCESS = '[Session State] Login Success',
  LOGIN_ERROR = '[Session State] Login Error',
  LOGIN_WAIT = '[Session State] Login Wait',
  // Logout
  LOGOUT = '[Session State] Logout',
  LOGOUT_SUCCESS = '[Session State] Logout Success',
  LOGOUT_ERROR = '[Session State] Logout Error',
  // Change Password Required
  CHANGE_PASSWORD = '[Session State] Change Password',
  CHANGE_PASSWORD_SUCCESS = '[Session State] Change Password Success',
  CHANGE_PASSWORD_ERROR = '[Session State] Change Password Error',
  CHANGE_PASSWORD_DENIED = '[Session State] Change Password Denied',
  // Recover Password
  RECOVER_PASSWORD = '[Session State] Recover Password',
  RECOVER_PASSWORD_SUCCESS = '[Session State] Recover Password Success',
  RECOVER_PASSWORD_ERROR = '[Session State] Recover Password Error',
  // TOTP
  UPDATE_AUTH_METHODS = '[Session State] update Auth Methods',
  TOTP_REGISTER_AUTH = '[Session State] Totp Register Auth',
  VERIFY_TOTP = '[Session State] Verify TOTP',
  VERIFY_METHOD = '[Session State] Verify Method Error',
  // Error
  RESET_ERROR = '[Session State] Reset Error'
}

// Token
export const updateTokens =                 createAction(Types.UPDATE_TOKENS,           props<{ token: string | null, refreshToken: string | null }>());
// Refresh Token
export const refreshTokenSuccess =          createAction(Types.REFRESH_TOKEN_SUCCESS,   props<{ token: string, refreshToken: string }>());
export const refreshTokenError =            createAction(Types.REFRESH_TOKEN_ERROR,     props<{ error: any }>());
// Login
export const login =                        createAction(Types.LOGIN,                   props<{ postLoginRequest: PostLoginRequest }>());
export const loginSuccess =                 createAction(Types.LOGIN_SUCCESS,           props<{ user: OraculoAPIUser }>());
export const loginError =                   createAction(Types.LOGIN_ERROR,             props<{ error: any }>());
export const loginWait =                    createAction(Types.LOGIN_WAIT,              props<{ user: OraculoAPIUser }>());
// Logout
export const logout =                       createAction(Types.LOGOUT);
export const logoutSuccess =                createAction(Types.LOGOUT_SUCCESS);
export const logoutError =                  createAction(Types.LOGOUT_ERROR,            props<{ error: any }>());
// Change Password Required
export const changePassword =               createAction(Types.CHANGE_PASSWORD,         props<{ postChangePasswordRequest: PostChangePasswordRequest }>());
export const changePasswordSuccess =        createAction(Types.CHANGE_PASSWORD_SUCCESS);
export const changePasswordError =          createAction(Types.CHANGE_PASSWORD_ERROR,   props<{ error: any }>());
// Recover Password   
export const recoverPassword =              createAction(Types.RECOVER_PASSWORD,        props<{ email: string }>());
export const recoverPasswordSuccess =       createAction(Types.RECOVER_PASSWORD_SUCCESS);
export const recoverPasswordError =         createAction(Types.RECOVER_PASSWORD_ERROR,  props<{ error: any }>());
// TOTP
export const updateAuthMethods =            createAction(Types.UPDATE_AUTH_METHODS,     props<{ authMethods: AuthMethods | null }>());
export const updateTotpRegisterAuth =       createAction(Types.TOTP_REGISTER_AUTH,      props<{ totpRegisterAuth: TotpRegisterAuth | null }>());
export const verifyTotp =                   createAction(Types.VERIFY_TOTP,             props<{ code: string }>());
export const verifyMethodError =            createAction(Types.VERIFY_METHOD,           props<{ verifyMethodError: string | null }>());
// Error
export const resetError =                   createAction(Types.RESET_ERROR);